import React, { useState, useEffect } from "react";
import { Modal, Select, Button, Typography, Space } from "antd";
import { getSingleStore } from "../../../../../../services/store.service";
import * as orderManagementActions from "../../../../../../redux/actions/orderManagement.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const Text = Typography;
const { Option } = Select;
const plainOptionsreason = [
  {label: "Bike accident", value: "Bike accident"},
  {label: "Mobile Data Package Expired", value: "Mobile Data Package Expired"},
  {label: "Incorrect Customer Address", value: "Incorrect Customer Address"},
  {label: "Incorrect Customer Location", value: "Incorrect Customer Location"},
  {label: "Forgot to Mark Drop-Off", value: "Forgot to Mark Drop-Off"},
  {label: "Network Issues", value: "Network Issues"},
  {label: "Order Status: Cancel to Completed", value: "Order Status: Cancel to Completed"},
];

const OrderComplete = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [postDataReason, setPostDataReason] = useState(null);
  const [postDataRiderID, setPostDataRiderID] = useState(null);
  const [complateRider, setComplateRider] = useState(null);

  useEffect(() => {
    if(props.visible === true){
      orderForceCompletedStatus()
    }
  }, [props.visible]);
  const orderForceCompletedStatus = async () => {
    try {
      setMBtnLoading(true);
      const {data} = await getSingleStore(props.OrderId);     
      if(data.code === 200){
        await props.orderManagementActions.orderForceCompletedStatusAction(data.data.zone.id).then(res=>{
          const riderData = [];
          res.data.data.map((item, i) => {
            let name = item.fullName+" - "+item.display_id;
            riderData.push(<Option key={item._id}>{name}</Option>);
          });
          setComplateRider(riderData);
        })
      }
    } catch (e) {} finally {
      setMBtnLoading(false);
    }
  }
  
  const handleChangeRider = (Value) => {
    setPostDataRiderID(Value);
  };

  const statusReason = (Value) => {
    setPostDataReason(Value);
  };

  const statusSubmit = async () => {
    try {
      setMBtnLoading(true);
      await props.orderManagementActions.updateOrderStatusAction({
        orderId: props.overviewdashboardid,
        statusSlug: "completed",
        reason: postDataReason,
        riderId: props.orderData[0].rider.id == null ? postDataRiderID: props.orderData[0].rider.id,
      },"Order Completed")
    } catch (e) {} finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };

  const handleCancel = () => {props.setvisible(false)};

  return (
    <Modal
      title="Complete Order"
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button loading={MBtnLoading} onClick={statusSubmit} disabled={postDataReason == null}>Order Complete</Button>,
      ]}
    >
      <Space direction="vertical" style={{width: "100%" }}>
        {props.orderData && props.orderData[0].rider.id == null?
        <Select
          showSearch
          allowClear
          filterOption={(input, option) =>  
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 
            || option.props.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          placeholder="Please select Rider"
          onChange={handleChangeRider}
          style={{width: "100%" }}
        >
          {complateRider}
        </Select>
        : ""}
        <Text>Reason</Text>
        <Select showSearch style={{ width: "100%" }} onChange={statusReason}>
          {plainOptionsreason &&
            plainOptionsreason.map((item) => (
              <Option key={item.value} value={item.value}>{item.label}</Option>
            ))}
        </Select>
      </Space>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  // return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderComplete);